import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from "react-toastify";
import { Dropdown, DropdownItem, DropdownMenu } from 'reactstrap';
import { api, constants, dateHelpers, helpers, UserContext } from '../utils';
const { ENDPOINTS } = constants;

export default function OrderDropdownMenu(props) {
   const userCtx = useContext(UserContext);
   const { currentUser, customerFilter } = userCtx;
   const navigate = useNavigate();

   const [open, setOpen] = useState(false);
   const [downloading, setDownloading] = useState(false);

   let customerId = null;
   if (currentUser?.isAnyCustomerTypeRole) {
      customerId = helpers.activeCustomerId(userCtx);
   } else if (props.customerId || customerFilter) {
      customerId = props.customerId || customerFilter.value;
   }

   function downloadInvoicePdf() {
      setDownloading(true)
      const payload = {
         InvoiceNumber: props.invoiceNumber,
         CustomerId: customerId,
         OrderId: props.orderId
      };
      api.postDownloadBinary(
         'Report/Invoice',
         payload,
         constants.MIME_TYPES.pdf,
         "ServiceThread_Invoice_" + props.invoiceNumber + ".pdf",
         "There was an error downloading this invoice pdf"
      )
         .then((res) => {
            if (res?.data === false) {
               toast.error(res.message);
            }
         })
         .catch(api.catchHandler)
         .finally(() => setDownloading(false));
   }

   function printOrderConfirmation() {
      setDownloading(true)
      const payload = {
         CustomerId: customerId,
         OrderId: props.orderId,
         OrderType: props.orderType
      };
      if (props.shipping) {
         payload.OrderType = 2;
      }
      api.postDownloadBinary(
         'Report/OrderConfirmation',
         payload,
         constants.MIME_TYPES.pdf,
         `OCR_${props.orderId}_${dateHelpers.toMDYDateString(new Date())}.pdf`,
         "There was an error downloading this order confirmation pdf"
      )
         .then((res) => {
            if (res?.data === false) {
               toast.error(res.message);
            }
         })
         .catch(api.catchHandler)
         .finally(() => setDownloading(false));
   }

   function printPackingSlip() {
      setDownloading(true)
      const payload = {
         InvoiceNumber: props.invoiceNumber,
         CustomerId: customerId,
         OrderId: props.orderId
      };
      if (props.isConsigned) {
         api.postDownloadBinary(
            `Transfer/PrintConsignedTransfer/${props.orderId}/${props.isConsigned}`,
            null,
            constants.MIME_TYPES.pdf,
            `Packing_List_${props.invoiceNumber ? props.invoiceNumber : props.orderId}_${dateHelpers.toMDYDateString(new Date())}.pdf`,
            "There was an error printing this packing slip"
         )
            .then((res) => {
               if (res?.data === false) {
                  toast.error(res.message);
               }
            })
            .catch(api.catchHandler)
            .finally(() => setDownloading(false));
      }
      else {
         api.postDownloadBinary(
            'Report/PackingSlip',
            payload,
            constants.MIME_TYPES.pdf,
            `Packing_List_${props.invoiceNumber ? props.invoiceNumber : props.orderId}_${dateHelpers.toMDYDateString(new Date())}.pdf`,
            "There was an error printing this packing slip"
         )
            .then((res) => {
               if (res?.data === false) {
                  toast.error(res.message);
               }
            })
            .catch(api.catchHandler)
            .finally(() => setDownloading(false));
      }
   }

   function printPickTicket() {
      setDownloading(true);
      const payload = {
         orderId: props.orderId,
         schedule: props.schedule
      };
      api
         .postDownloadBinary(
            "Report/GetPickTicketReport",
            payload,
            constants.MIME_TYPES.pdf,
            `Pick_Ticket_${props.orderId}.pdf`,
            "There was an error downloading this report."
         )
         .then((response) => {
            if (response?.data === false) {
               toast.error(response.message);
            }
         })
         .catch(api.catchHandler)
         .finally(() => setDownloading(false));
   }

   return (
      <td
         className="data-cell"
         onMouseEnter={() => setOpen(true)}
         onMouseLeave={() => setOpen(false)}
         style={{ position: "relative" }}
      >
         <span className="shredLink fw-bold">{props.invoiceNumber || props.orderId}</span>
         <Dropdown
            isOpen={open}
            toggle={() => setOpen(!open)}
            style={{ position: "absolute", top: "1.75em", left: "2em" }}
         >
            <DropdownMenu>
               {props.invoiceNumber || props.cosigned || props.isConsigned
                  ? null
                  : (<DropdownItem className="sort-handle" onClick={printOrderConfirmation} disabled={downloading} >
                     Print Order Confirmation
                  </DropdownItem>)
               }
               <DropdownItem className="sort-handle" onClick={printPackingSlip} disabled={downloading} >
                  Print Packing Slip
               </DropdownItem>
               {props.invoiceNumber
                  ? (<DropdownItem className="sort-handle" onClick={downloadInvoicePdf} disabled={downloading} >
                     Print Invoice
                  </DropdownItem>)
                  : null
               }
               {(userCtx.currentUser?.isAPUCS || userCtx.currentUser?.isSalesperson || userCtx.currentUser?.isCSRRole) && !props.showInvoiceSettings && !props.hideCoALateShip
                  ? (<DropdownItem className="sort-handle">
                     <div
                        onClick={() => navigate(ENDPOINTS.createCoA, {
                           state: {
                              currentCustomer: {
                                 Customer: { value: props.customerId || (customerFilter && customerFilter.value), label: props.customerLabel },
                                 isConsignedCustomer: props.isConsigned ? true : false
                              },
                              currentOrder: { value: props.orderId, label: props.orderId },
                              currentItem: { value: props.itemNumber, label: props.itemLabel }
                           }
                        })}
                     >
                        CoA Search
                     </div>
                  </DropdownItem>)
                  : null
               }
               { // eslint-disable-next-line no-mixed-operators
                  props.includeShipOptions || props.isConsigned &&
                     (userCtx.currentUser?.isAPUCS
                        || userCtx.isCSRRole
                        || userCtx.isWarehouseRole
                        || userCtx.isInventoryEdit
                        // || userCtx.currentUser?.isSalesperson
                     )
                     ? (<DropdownItem className="sort-handle">
                        <a rel="noreferrer"
                           className="text-link"
                           href={`bill-of-lading/${JSON.stringify({
                              orderId: props.orderId,
                              orderType: props.orderType,
                           })}`}
                           target="_blank"
                        >
                           Bill Of Lading
                        </a>
                     </DropdownItem>)
                     : null
               }
               {(userCtx.currentUser?.isAPUCS || userCtx.currentUser?.isSalesperson) && !props.showInvoiceSettings && !props.hideCoALateShip && !props.isConsigned
                  ? <DropdownItem className="sort-handle">
                     <div
                        onClick={() => navigate(ENDPOINTS.lateShipment, {
                           state: {
                              customer: {
                                 value: props.customerId || (customerFilter && customerFilter.value),
                                 label: props.customerLabel
                              },
                              orderId: props.orderId
                           }
                        })}
                     >
                        Late Shipment
                     </div>
                  </DropdownItem>
                  : null
               }
               {props.includeShipOptions && (userCtx.currentUser?.isAPUCS || userCtx.currentUser?.isSalesperson || userCtx.currentUser?.isWarehouseEdit)
                  ? <DropdownItem className="sort-handle">
                     <div onClick={props.onAddFreightQuote} >
                        Add Freight Quote
                     </div>
                  </DropdownItem>
                  : null
               }
               {props.includeShipOptions && (userCtx.currentUser?.isAPUCS || userCtx.currentUser?.isSalesperson)
                  ? <DropdownItem className="sort-handle">
                     <div onClick={props.onAddTrackingNumber} >
                        Add Tracking Number
                     </div>
                  </DropdownItem>
                  : null
               }
               {(userCtx.currentUser?.isAPUCS || userCtx.currentUser?.isCSRView || userCtx.currentUser?.isSalesperson) && !props.isConsigned
                  ? <DropdownItem
                     onClick={() => navigate(`/attachments/${constants.ATTACHMENT_TYPES.SalesOrderInvoice}/${(props.attachmentKey || props.orderId)}`)}
                     className="sort-handle"
                  >
                     Attachments {props.attachmentCount > -1 ? `(${props.attachmentCount})` : null}
                  </DropdownItem>
                  : null
               }
               {props.isScan ? (
                  <DropdownItem onClick={() => props.scanCallback(props.order)} className="sort-handle" >
                     Scan Order
                  </DropdownItem>
               ) : null}
               {props.isPick ? (
                  <DropdownItem onClick={() => printPickTicket()} className="sort-handle" >
                     Pick Ticket
                  </DropdownItem>
               ) : null}
               {props.showInvoiceSettings
                  ? <DropdownItem>
                     <div onClick={props.onChangeInvoiceSettings} className="sort-handle">
                        Settings
                     </div>
                  </DropdownItem>
                  : null}
            </DropdownMenu>
         </Dropdown>
      </td >
   )
}